import {CopilotAvatar} from '@github-ui/copilot-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {AlertIcon} from '@primer/octicons-react'
import {Button, IconButton, Link as PrimerLink} from '@primer/react'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'
import {clsx} from 'clsx'
import {useModifyReviewers} from '../../../mutations/use-modify-reviewers'
import {usePullRequestAnalytics} from '../../../hooks/use-pull-request-analytics'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'
import styles from './Reviewers.module.css'

export function CopilotSuggestionRow({reviewer}: {reviewer: Reviewer}) {
  const {helpUrl} = useLayoutRouteData()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const {mutate: modifyReviewers, isError, isPending} = useModifyReviewers()
  const copilotSlug = reviewer.slug || reviewer.displayLogin
  const hovercardAttrs = useGetHovercardAttributesForType()('copilot', {botSlug: copilotSlug})

  const requestReview = () => {
    sendPullRequestAnalyticsEvent('overview.add_reviewer', 'OVERVIEW_REVIEWER')
    modifyReviewers({
      addReviewers: [{reviewerId: Number(reviewer.id), isTeam: false}],
      removeReviewers: [],
    })
  }

  return (
    <li className={styles.reviewerRow}>
      <PrimerLink
        aria-label="Learn about Copilot code review"
        href={`${helpUrl}/copilot/how-tos/use-copilot-agents/request-a-code-review/use-code-review`}
        muted
        className={styles.reviewerIdentity}
        {...hovercardAttrs}
      >
        <CopilotAvatar isDecorative />
        <span className={styles.reviewerName}>Copilot</span>
      </PrimerLink>
      {isError && (
        <IconButton
          aria-label="The review request failed. Please try again."
          className={clsx(styles.statusIcon, 'color-fg-danger')}
          icon={AlertIcon}
          size="small"
          tooltipDirection="nw"
          variant="invisible"
        />
      )}
      <Button
        aria-label="Request review from Copilot"
        className={styles.requestReviewButton}
        onClick={requestReview}
        variant="link"
        loading={isPending}
        loadingAnnouncement="Requesting review from Copilot"
      >
        Request
      </Button>
    </li>
  )
}
